<template>
  <div class="px-4 md:px-0">
    <div id="guide-section" class="">
      <div class="">{{ $t('Guide') }}</div>
      <h2 class="text-4xl font-medium mb-4">
        {{ content.Title }}
      </h2>
      <div class="text-xl mb-10">
        {{ $t('Discover our complete guide to visiting {city-name}.', { 'city-name': cityDisplayName }) }}
      </div>
      <div id="guide-section-list">
        <div v-for="(guideElement, index) in content.items" :key="index" class="guide-section-element relative mb-4">
          <h3 class="font-semibold text-4xl mb-2">
            {{ guideElement.title }}
          </h3>
          <div class="guide-section-element-description">
            <div v-processlinks :id="`guide-element-first-${index}`" v-html="getFirstParagraph(guideElement.content)"></div>
            <div v-processlinks :id="`guide-element-last-${index}`" v-html="getHiddenText(guideElement.content)" class="hidden"></div>
          </div>
          <button
            v-if="hasHiddenText(guideElement.content)"
            @click="toggleText(index)"
            class="mt-2 md:mt-4 text-Tourscanner_blue-700 hover:text-blue-800"
          >
            {{ buttonText(index) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale, t } = useI18n();

const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  cityDisplayName: {
    type: String,
    required: true,
  },
});

const openState = ref({});

const getFirstParagraph = (content) => {
  const paragraphs = content.split('</p>');
  return paragraphs[0] + '</p>';
};

const getHiddenText = (content) => {
  const paragraphs = content.split('</p>');
  paragraphs.shift();
  return paragraphs.join('</p>');
};

const hasHiddenText = (content) => {
  return getHiddenText(content).length > 0;
};

const buttonText = (index) => {
  return openState.value[index] ? t('+ Read less') : t('+ Read more');
};

const toggleText = (index) => {
  openState.value = {
    ...openState.value,
    [index]: !openState.value[index],
  };
  const target = document.querySelector(`#guide-element-last-${index}`);
  target.classList.toggle('hidden');
};

onMounted(() => {
  document.querySelectorAll('#guide-section a').forEach(link => {
    link.setAttribute('target', '_blank');
  });
});
</script>

<style scoped>
:deep(h2) {
  @apply text-4xl font-semibold mb-4;
}

:deep(p) {
  @apply py-2;
}
</style>
